import { useContext } from "react";
import { FormBuilderContext } from "../FormBuilderContext";
import "./Inputs.less";
import { Switch } from "../../../BP2Components";
import InputActions from "../InputActions/InputActions";
import IntlMessages from "../../../../util/IntlMessages";
import { getDecorators } from "../../../../util/getDecorators";

const BooleanInput = ({ item, onStartEdit, onDuplicate, onDelete }) => {
   const { previewMode } = useContext(FormBuilderContext);
   const decoratorMap = getDecorators(item.decorators);

   const required = decoratorMap?.RequiredDecorator?.required ?? false;
   const hide = decoratorMap?.HideFieldDecorator?.hide ?? false;
   const editable = decoratorMap?.EditableDecorator?.edit ?? true;

   if (previewMode && (item.hidden || hide)) return null;

   return (
      <>
         <div data-field-id={item?.name} className="form-builder-input">
            <div className="form-builder-input-label form-builder-input-switch">
               <div>
                  <Switch
                     defaultChecked={false}
                     id={item?.name}
                     readOnly={!previewMode}
                     onStartEdit={onStartEdit}
                     disabled={!editable}
                  />
               </div>

               <label htmlFor={item?.name}>
                  {(item.required || required) && (
                     <span className="form-builder-input-required">*</span>
                  )}
                  {item.label}
                  {(item.hidden || hide) && (
                     <span className="form-builder-input-label-hidden">
                        (<IntlMessages id="form.hiddenField" />)
                     </span>
                  )}
                  :
               </label>
            </div>

            <InputActions onStartEdit={onStartEdit} onDuplicate={onDuplicate} onDelete={onDelete} />
         </div>
      </>
   );
};

export default BooleanInput;
